import { FC, useEffect } from 'react';
import {
  Container,
  Box,
  Tooltip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { observer } from "mobx-react"
import store from "./store"
import { useTranslation } from 'react-i18next';
import { GridColDef, GridActionsCellItem } from '@mui/x-data-grid';
import PopupGrid from 'components/PopupGrid';
import IncomingDocumentPopupForm from './../IncomingDocumentAddEditView/popupForm'
import CustomButton from 'components/Button';
import dayjs from 'dayjs';
import FileViewer from "components/FileViewer";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChecklistIcon from '@mui/icons-material/Checklist';
import MainStore from 'MainStore';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";

type IncomingDocumentListViewProps = {
  idMain: number;
  disableEdit: boolean;
};

const IncomingDocumentListView: FC<IncomingDocumentListViewProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    if (store.idMain !== props.idMain) {
      store.idMain = props.idMain
    }
    store.loadIncomingDocuments()
    return () => store.clearStore()
  }, [props.idMain])

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const columns: GridColDef[] = [
    // {
    //   field: 'name',
    //   headerName: translate("label:incomingDocumentListView.name"),
    //   flex: 1,
    //   renderCell: (param) => (<div data-testid="table_incoming_document_column_name"> {param.row.name} </div>),
    //   renderHeader: (param) => (<div data-testid="table_incoming_document_header_name">{param.colDef.headerName}</div>)
    // },
    // {
    //   field: 'document_type_name',
    //   headerName: translate("label:incomingDocumentListView.document_type_id"),
    //   flex: 1,
    //   renderCell: (param) => (<div data-testid="table_incoming_document_column_document_type_id"> {param.row.document_type_name} </div>),
    //   renderHeader: (param) => (<div data-testid="table_incoming_document_header_document_type_id">{param.colDef.headerName}</div>)
    // },
    {
      field: 'upload_id',
      flex: 1,
      headerName: translate("ЭЦП"),
      renderCell: (param) => {
        return <div>
          {/* <Tooltip title={translate("Подписать")}>
            <IconButton size='small' disabled={MainStore.currentUser.has_signing_rights} onClick={() => store.signApplicationPayment(param.row.id, 0, () => { })}>
              <AssignmentIcon />
            </IconButton>
          </Tooltip> */}
          <Tooltip title={translate("Подписавшие")}>
            <IconButton size='small' onClick={() => {
              store.ecpListOpen = true;
              store.loadGetSignByFileId(param.row.id)
            }}>
              <ChecklistIcon />
            </IconButton>
          </Tooltip>
        </div>
      },
    },
    {
      field: 'file_name',
      headerName: translate("label:incomingDocumentListView.file_name"),
      flex: 1,
      renderCell: (param) => (<div data-testid="table_incoming_document_column_file_name"> {param.row.file_name} </div>),
      renderHeader: (param) => (<div data-testid="table_incoming_document_header_file_name">{param.colDef.headerName}</div>)
    },
    // {
    //   field: 'bga_document_number',
    //   headerName: translate("label:incomingDocumentListView.bga_document_number"),
    //   flex: 1,
    //   renderCell: (param) => (<div data-testid="table_incoming_document_column_bga_document_number"> {param.row.bga_document_number} </div>),
    //   renderHeader: (param) => (<div data-testid="table_incoming_document_header_bga_document_number">{param.colDef.headerName}</div>)
    // },
    // {
    //   field: 'bga_document_date',
    //   headerName: translate("label:incomingDocumentListView.bga_document_date"),
    //   flex: 1,
    //   renderCell: (param) => (
    //     <div data-testid="table_incoming_document_column_bga_document_date">
    //       {param.row.bga_document_date ? dayjs(param.row.bga_document_date).format('DD.MM.YYYY') : ''}
    //     </div>
    //   ),
    //   renderHeader: (param) => (<div data-testid="table_incoming_document_header_bga_document_date">{param.colDef.headerName}</div>)
    // },
    {
      field: 'received_at',
      headerName: translate("label:incomingDocumentListView.received_at"),
      flex: 1,
      renderCell: (param) => (
        <div data-testid="table_incoming_document_column_received_at">
          {param.row.received_at ? dayjs(param.row.received_at).format('DD.MM.YYYY HH:mm') : ''}
        </div>
      ),
      renderHeader: (param) => (<div data-testid="table_incoming_document_header_received_at">{param.colDef.headerName}</div>)
    },
  ];

  return (
    <Container maxWidth='xl' sx={{ mt: 4 }}>
      <PopupGrid
        title={translate("label:incomingDocumentListView.entityTitle")}
        onDeleteClicked={(id: number) => store.deleteIncomingDocument(id)}
        onEditClicked={(id: number) => store.onEditClicked(id)}
        columns={columns}
        hideAddButton
        hideDeleteButton={true}
        hideEditButton={true}
        customActionButton={(id: number) => {
          const row = store.data.find((item: any) => item.id === id);
          return (
            <><GridActionsCellItem
              icon={<Tooltip title={translate("download")}><DownloadIcon /></Tooltip>}
              label="Download"
              data-testid={`download_button_${id}`}
              onClick={() => store.downloadFile(id, row?.name || '')}
              color="inherit"
            />
              <GridActionsCellItem
                icon={<Tooltip title={translate("view")}><RemoveRedEyeIcon /></Tooltip>}
                label="View"
                data-testid={`download_button_${id}`}
                onClick={() => store.OpenFileFile(id, row?.file_name || '')}
                color="inherit"
              />
            </>
          );
        }}
        // customBottom={
        //   <Box>
        //     <CustomButton
        //       variant='contained'
        //       sx={{ mb: 1 }}
        //       id={`incomingDocumentAddButton`}
        //       onClick={() => store.onEditClicked(0)}
        //       endIcon={<AddIcon />}
        //     >
        //       {translate('add')}
        //     </CustomButton>
        //   </Box>
        // }
        data={store.data}
        tableName="incoming_document"
      />

      <IncomingDocumentPopupForm
        openPanel={store.openPanel}
        id={store.currentId}
        onBtnCancelClick={() => store.closePanel()}
        onSaveClick={() => {
          store.closePanel()
          store.loadIncomingDocuments()
        }}
      />

      <FileViewer
        isOpen={store.isOpenFileView}
        onClose={() => { store.isOpenFileView = false }}
        fileUrl={store.fileUrl}
        fileType={store.fileType} />


      <Dialog
        open={store.ecpListOpen}
        onClose={() => { store.ecpListOpen = false; }}
        maxWidth="md"
        fullWidth
      >
        <DialogActions>
          <IconButton
            aria-label="close"
            onClick={() => { store.ecpListOpen = false; }}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogContent sx={{ justifyItems: 'center' }}>
          <h3>Список подписавших документ</h3>
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-100 border-b">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                      ФИО
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                      Отдел
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                      Дата подписания
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {store.signData.map((row, index) => (
                    <tr
                      key={row.id}
                      className={`hover:bg-blue-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                        }`}
                    >
                      <td className="px-4 py-4 border-b border-gray-200">
                        <span className="text-sm font-medium text-gray-900">
                          {row.employee_fullname || 'Не указано'}
                        </span>
                      </td>
                      <td className="px-4 py-4 border-b border-gray-200">
                        <span className="text-sm text-gray-700">
                          {row.structure_fullname || 'Не указано'}
                        </span>
                      </td>
                      <td className="px-4 py-4 border-b border-gray-200">
                        <span className="text-sm font-mono text-gray-800">
                          {formatDateTime(row.timestamp)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>


          </div>

        </DialogContent>
      </Dialog>
    </Container>
  );
})

export default IncomingDocumentListView